module.exports = __webpack_public_path__ + "static/media/snail.bbbe7b78.svg";